import wrapWithProvider from "./src/state/createStore"
import "./src/styles/main.scss"

export const wrapRootElement = wrapWithProvider
